var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MhRadio"},_vm._l((_vm.item.options||_vm.ajaxOptions),function(o){return _c('el-radio',{key:o[_vm.item.key],attrs:{"label":o[_vm.item.key],"disabled":o[_vm.item.disabled]}},[_vm._v(" "+_vm._s(o[_vm.item.label])+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }